import { render, staticRenderFns } from "./three_menu.vue?vue&type=template&id=a4e0ecd0&"
import script from "./three_menu.vue?vue&type=script&lang=js&"
export * from "./three_menu.vue?vue&type=script&lang=js&"
import style0 from "./three_menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports